module.exports = (RESTService) ->
  'ngInject'
  RESTService.setFullResponse(true).service('admin/payments')
